import CheckBox from '@/common/components/base/checkBox/CheckBox.tsx';
import { Box, Center, Flex, Stack } from 'styled-system/jsx';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems.tsx';
import { FileAcceptCheckBoxCardType } from '@/modules/FileList/components/FileAcceptCheckBoxCard/FileAcceptCheckBoxCard.type.ts';
import { useFormContext } from 'react-hook-form';

export default ({ name, ListData }: FileAcceptCheckBoxCardType) => {
  const { setValue, getValues } = useFormContext();
  const onCardClick = () => {
    setValue(name, !getValues(name));
  };
  return (
    <Box
      onClick={onCardClick}
      mb={'10px'}
      backgroundColor="white"
      borderRadius="8px"
      padding="10px 15px"
    >
      <Flex alignItems="center">
        <Center
          height="60px"
          borderLeft="1px solid {colors.gray-2} "
          paddingLeft="15px"
          marginLeft="15px"
        >
          <CheckBox name={name} />
        </Center>
        <Stack flex={1}>
          <DetailCardItems backgroundColor="orange-2" items={ListData} />
        </Stack>
      </Flex>
    </Box>
  );
};
